import actionConstants from '../constants/';
import { matchesApiCancelKey } from '../apiCancelKeys';

const CLEARED_REQUEST_ID = '@overview/CLEARED_REQUEST';

const todayTransactionsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const todayEdgeTransactionsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const overviewState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const edgeOverviewState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const overviewSettlementsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const overviewEdgeSettlementsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const initialBetaToggleState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: null as any,
  errorMessage: '',
};

const checkoutInsightsPaymentPerformanceState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const checkoutInsightsOfferEffectivenessState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const checkoutInsightsPaymentModeBreakdownState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const checkoutInsightsConversionFunnelState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const initialState = {
  todayTransactionsState: { ...todayTransactionsState },
  overviewState: { ...overviewState },
  overviewSettlementsState: { ...overviewSettlementsState },
  todayEdgeTransactionsState: { ...todayEdgeTransactionsState },
  overviewEdgeSettlementsState: { ...overviewEdgeSettlementsState },
  edgeOverviewState: { ...edgeOverviewState },
  initialBetaToggleState: {...initialBetaToggleState},
  checkoutInsightsOfferEffectivenessState: { ...checkoutInsightsOfferEffectivenessState },
  checkoutInsightsPaymentModeBreakdownState: { ...checkoutInsightsPaymentModeBreakdownState },
  checkoutInsightsPaymentPerformanceState: { ...checkoutInsightsPaymentPerformanceState },
  checkoutInsightsConversionFunnelState: { ...checkoutInsightsConversionFunnelState },
};

const isStaleResponse = (
  activeRequestId: string,
  responseRequestId?: string
) => Boolean(activeRequestId && activeRequestId !== responseRequestId);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function overview(state = initialState, action) {
  switch (action.type) {
    case actionConstants.CANCEL_API_REQUEST:
      return {
        ...state,
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA
        )
          ? {
              todayEdgeTransactionsState: {
                ...state.todayEdgeTransactionsState,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_EDGE_OVERVIEW_DATA
        )
          ? {
              edgeOverviewState: {
                ...state.edgeOverviewState,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA
        )
          ? {
              overviewEdgeSettlementsState: {
                ...state.overviewEdgeSettlementsState,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_ACTION
        )
          ? {
              checkoutInsightsPaymentPerformanceState: {
                ...state.checkoutInsightsPaymentPerformanceState,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_ACTION
        )
          ? {
              checkoutInsightsOfferEffectivenessState: {
                ...state.checkoutInsightsOfferEffectivenessState,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_ACTION
        )
          ? {
              checkoutInsightsPaymentModeBreakdownState: {
                ...state.checkoutInsightsPaymentModeBreakdownState,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_ACTION
        )
          ? {
              checkoutInsightsConversionFunnelState: {
                ...state.checkoutInsightsConversionFunnelState,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
      };

    case actionConstants.GET_BETA_TOGGLE_REQUEST:
      return{
        ...state,
        initialBetaToggleState:{
          ...state.initialBetaToggleState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

      case actionConstants.GET_BETA_TOGGLE_SUCCESS:
        return{
          ...state,
          initialBetaToggleState:{
            ...state.initialBetaToggleState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action?.payload?.body
          },
        };

        case actionConstants.GET_BETA_TOGGLE_FAILURE: 
        return {
          ...state,
          initialBetaToggleState:{
            ...state.initialBetaToggleState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
          },
        };
        case actionConstants.CLEAR_BETA_TOGGLE_STATE:
          return{
            ...state,
            initialBetaToggleState,
          };
    case actionConstants.GET_TODAY_TRANSACTIONS_DATA_REQUEST:
      return {
        ...state,
        todayTransactionsState: {
          ...state.todayTransactionsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_TODAY_TRANSACTIONS_DATA_SUCCESS:
      return {
        ...state,
        todayTransactionsState: {
          ...state.todayTransactionsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_TODAY_TRANSACTIONS_DATA_FAILURE:
      return {
        ...state,
        todayTransactionsState: {
          ...state.todayTransactionsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_TODAY_TRANSACTIONS_DATA_CLEAR:
      return {
        ...state,
        todayTransactionsState,
      };

    case actionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_REQUEST:
      return {
        ...state,
        todayEdgeTransactionsState: {
          ...state.todayEdgeTransactionsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_SUCCESS:
      if (
        isStaleResponse(
          state.todayEdgeTransactionsState.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        todayEdgeTransactionsState: {
          ...state.todayEdgeTransactionsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_FAILURE:
      if (
        isStaleResponse(
          state.todayEdgeTransactionsState.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        todayEdgeTransactionsState: {
          ...state.todayEdgeTransactionsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA_CLEAR:
      return {
        ...state,
        todayEdgeTransactionsState: {
          ...todayEdgeTransactionsState,
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_OVERVIEW_DATA_REQUEST:
      return {
        ...state,
        overviewState: {
          ...state.overviewState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_OVERVIEW_DATA_SUCCESS:
      return {
        ...state,
        overviewState: {
          ...state.overviewState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_OVERVIEW_DATA_FAILURE:
      return {
        ...state,
        overviewState: {
          ...state.overviewState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_OVERVIEW_DATA_CLEAR:
      return {
        ...state,
        overviewState,
      };

    case actionConstants.GET_EDGE_OVERVIEW_DATA_REQUEST:
      return {
        ...state,
        edgeOverviewState: {
          ...state.edgeOverviewState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_EDGE_OVERVIEW_DATA_SUCCESS:
      if (
        isStaleResponse(
          state.edgeOverviewState.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        edgeOverviewState: {
          ...state.edgeOverviewState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_EDGE_OVERVIEW_DATA_FAILURE:
      if (
        isStaleResponse(
          state.edgeOverviewState.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        edgeOverviewState: {
          ...state.edgeOverviewState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_EDGE_OVERVIEW_DATA_CLEAR:
      return {
        ...state,
        edgeOverviewState: {
          ...edgeOverviewState,
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };
    case actionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_REQUEST:
      return {
        ...state,
        overviewSettlementsState: {
          ...state.overviewSettlementsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_SUCCESS:
      return {
        ...state,
        overviewSettlementsState: {
          ...state.overviewSettlementsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_FAILURE:
      return {
        ...state,
        overviewSettlementsState: {
          ...state.overviewSettlementsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_SETTLEMENTS_OVERVIEW_DATA_CLEAR:
      return {
        ...state,
        overviewSettlementsState,
      };

      case actionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_REQUEST:
        return {
          ...state,
          checkoutInsightsOfferEffectivenessState: {
            ...state.checkoutInsightsOfferEffectivenessState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            activeRequestId: action.payload?.requestId ?? '',
          },
      };
  
      case actionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_SUCCESS:
        if (
          isStaleResponse(
            state.checkoutInsightsOfferEffectivenessState.activeRequestId,
            action.payload?.extra?.requestId
          )
        ) {
          return state;
        }
        return {
          ...state,
          checkoutInsightsOfferEffectivenessState: {
            ...state.checkoutInsightsOfferEffectivenessState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            activeRequestId: '',
          },
        };
  
      case actionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_FAILURE:
        if (
          isStaleResponse(
            state.checkoutInsightsOfferEffectivenessState.activeRequestId,
            action.payload?.extra?.requestId
          )
        ) {
          return state;
        }
        return {
          ...state,
          checkoutInsightsOfferEffectivenessState: {
            ...state.checkoutInsightsOfferEffectivenessState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: action.payload.body,
            activeRequestId: '',
          },
        };
  
      case actionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_CLEAR:
        return {
          ...state,
          checkoutInsightsOfferEffectivenessState: {
            ...checkoutInsightsOfferEffectivenessState,
            activeRequestId: CLEARED_REQUEST_ID,
          },
        };

        case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_REQUEST:
          return {
            ...state,
            checkoutInsightsPaymentPerformanceState: {
              ...state.checkoutInsightsPaymentPerformanceState,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
              activeRequestId: action.payload?.requestId ?? '',
            },
        };
    
        case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_SUCCESS:
          if (
            isStaleResponse(
              state.checkoutInsightsPaymentPerformanceState.activeRequestId,
              action.payload?.extra?.requestId
            )
          ) {
            return state;
          }
          return {
            ...state,
            checkoutInsightsPaymentPerformanceState: {
              ...state.checkoutInsightsPaymentPerformanceState,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
              activeRequestId: '',
            },
          };
    
        case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_FAILURE:
          if (
            isStaleResponse(
              state.checkoutInsightsPaymentPerformanceState.activeRequestId,
              action.payload?.extra?.requestId
            )
          ) {
            return state;
          }
          return {
            ...state,
            checkoutInsightsPaymentPerformanceState: {
              ...state.checkoutInsightsPaymentPerformanceState,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
              data: action.payload.body,
              activeRequestId: '',
            },
          };
    
        case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_CLEAR:
          return {
            ...state,
            checkoutInsightsPaymentPerformanceState: {
              ...checkoutInsightsPaymentPerformanceState,
              activeRequestId: CLEARED_REQUEST_ID,
            },
          };

          case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_REQUEST:
            return {
              ...state,
              checkoutInsightsPaymentModeBreakdownState: {
                ...state.checkoutInsightsPaymentModeBreakdownState,
                isLoading: true,
                isSuccess: false,
                isFailure: false,
                activeRequestId: action.payload?.requestId ?? '',
              },
          };
      
          case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_SUCCESS:
            if (
              isStaleResponse(
                state.checkoutInsightsPaymentModeBreakdownState.activeRequestId,
                action.payload?.extra?.requestId
              )
            ) {
              return state;
            }
            return {
              ...state,
              checkoutInsightsPaymentModeBreakdownState: {
                ...state.checkoutInsightsPaymentModeBreakdownState,
                isLoading: false,
                isSuccess: true,
                isFailure: false,
                data: action.payload.body,
                activeRequestId: '',
              },
            };
      
          case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_FAILURE:
            if (
              isStaleResponse(
                state.checkoutInsightsPaymentModeBreakdownState.activeRequestId,
                action.payload?.extra?.requestId
              )
            ) {
              return state;
            }
            return {
              ...state,
              checkoutInsightsPaymentModeBreakdownState: {
                ...state.checkoutInsightsPaymentModeBreakdownState,
                isLoading: false,
                isSuccess: false,
                isFailure: true,
                data: action.payload.body,
                activeRequestId: '',
              },
            };
      
          case actionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_CLEAR:
            return {
              ...state,
              checkoutInsightsPaymentModeBreakdownState: {
                ...checkoutInsightsPaymentModeBreakdownState,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            };

        case actionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_REQUEST:
          return {
            ...state,
            checkoutInsightsConversionFunnelState: {
              ...state.checkoutInsightsConversionFunnelState,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
              activeRequestId: action.payload?.requestId ?? '',
            },
          };

        case actionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_SUCCESS:
          if (
            isStaleResponse(
              state.checkoutInsightsConversionFunnelState.activeRequestId,
              action.payload?.extra?.requestId
            )
          ) {
            return state;
          }
          return {
            ...state,
            checkoutInsightsConversionFunnelState: {
              ...state.checkoutInsightsConversionFunnelState,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
              activeRequestId: '',
            },
          };

        case actionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_FAILURE:
          if (
            isStaleResponse(
              state.checkoutInsightsConversionFunnelState.activeRequestId,
              action.payload?.extra?.requestId
            )
          ) {
            return state;
          }
          return {
            ...state,
            checkoutInsightsConversionFunnelState: {
              ...state.checkoutInsightsConversionFunnelState,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
              data: action.payload.body,
              errorMessage: action.payload.body?.detail
                || action.payload.body?.title
                || action.payload.body?.message
                || 'Failed to fetch conversion funnel data',
              errorCode: action.payload.body?.status
                || action.payload.body?.error_code
                || 0,
              activeRequestId: '',
            },
          };

        case actionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_CLEAR:
          return {
            ...state,
            checkoutInsightsConversionFunnelState: {
              ...checkoutInsightsConversionFunnelState,
              activeRequestId: CLEARED_REQUEST_ID,
            },
          };

    case actionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_REQUEST:
      return {
        ...state,
        overviewEdgeSettlementsState: {
          ...state.overviewEdgeSettlementsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_SUCCESS:
      if (
        isStaleResponse(
          state.overviewEdgeSettlementsState.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        overviewEdgeSettlementsState: {
          ...state.overviewEdgeSettlementsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_FAILURE:
      if (
        isStaleResponse(
          state.overviewEdgeSettlementsState.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        overviewEdgeSettlementsState: {
          ...state.overviewEdgeSettlementsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_EDGE_SETTLEMENTS_OVERVIEW_DATA_CLEAR:
      return {
        ...state,
        overviewEdgeSettlementsState: {
          ...overviewEdgeSettlementsState,
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    default:
      return {
        ...state,
      };
  }
}
